import gql from 'graphql-tag';

export const gqlGetCntContributionTemplates = gql`
  query getCntContributionTemplates($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributionTemplates(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        name
        fromDate
        tillDate
        isActive
      }
      recordCount
    }
  }
`;

/** Κεφαλίδα template και τα είδη που αντιγράφονται σε νέα εισφορά */
export const gqlGetCntContributionTemplateById = gql`
  query getCntContributionTemplateById($id: Int) {
    getCntContributionTemplateById(id: $id) {
      id
      name
      fromDate
      tillDate
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      cntContributionTemplatesItems {
        id
        aa
        itemId
        isActive
        cntItem {
          id
          code
          name
          units1
          units2
          priceCalculationMethod
          group {
            id
            name
          }
          subgroup {
            id
            name
          }
          itemPrices {
            id
            fromDate
            price
            isActive
          }
        }
      }
    }
  }
`;
